export default __webpack_public_path__ + "808e1f488d20b5a2324ab0d86d4aa3de.svg";